import { IconPropsInterface } from "./typings";

export default function FontAwesomeIcons({ icon, className }: IconPropsInterface) {
    return (<i className={`fas fa-${icon} ${className}`}></i>);
}
